var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeistungenPinnnadel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.66 38.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #c94747;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #d0d0d0;\n      }\n\n      .cls-3 {\n        fill: #ed4c5c;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m14.42,22.04C10.49,26.36,1.69,36.94.37,38.26c-.01.01-.03.03-.04.04-.53.53-.37.69.16.16,1.16-1.16,11.92-10.11,16.27-14.09l-2.34-2.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.02,
    y: 9.76,
    width: 18.68,
    height: 9.52,
    transform: "translate(-3.13 21.48) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m25.63,33.25c.51-4.61-1.5-10.05-5.77-14.32-4.27-4.27-9.72-6.29-14.32-5.77l20.09,20.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m37.66,14.59c-3.09.34-6.74-1.01-9.6-3.87-2.85-2.86-4.21-6.51-3.87-9.59l13.47,13.46Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeistungenPinnnadel);
export default __webpack_public_path__ + "static/media/leistungen-pinnnadel.074d7df92d2b520ca8d01d1e469bd894.svg";
export { ForwardRef as ReactComponent };